<template>
    <Layout>
        <div v-if="locale == 'fr'" class="prose mx-auto flex max-w-5xl flex-col space-y-4 py-10">
            <div class="prose mx-auto">
                <h2>Politique de Confidentialité et d'utilisation</h2>
                <p>
                    Nous utilisons des cookies et des technologies similaires pour améliorer l'expérience des utilisateurs sur notre site.
                    Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter certaines fonctionnalités du
                    site. En continuant, vous acceptez nos politiques d’utilisation et de confidentialité.
                </p>

                <h2>Conditions d’Utilisation</h2>
                <p>
                    Les noms AEROEMPLOI, AEROWEB, AEROCAREER, CAMAQ les logo d'Aeroemploi, y compris le symbole des rayons, sont des
                    marques déposées de Aéro Emploi Inc. Tous les droits de reproduction sont la propriété de Aéro Emploi Inc., y compris
                    les droits de reproduction dans le logo d'Aero Emploi Inc. Tous droits réservés.
                </p>

                <h2>Avis Légal</h2>
                <p>
                    Les informations contenues dans ce site Web sont d’ordre général et ne prétendent pas remplacer le conseil personnalisé
                    de professionnels tenant compte des particularités d’un cas précis. Malgré tout le soin consacré à sa préparation, nous
                    ne pouvons garantir l’exactitude, l’actualité, la fiabilité, ni l’exhaustivité des informations qu’il contient. Aéro
                    Emploi Inc., ses sociétés affiliées, partenaires et employés ne peuvent être tenus pour responsables d’aucun dommage ou
                    perte en lien avec l’utilisation de ces informations.
                </p>
                <p>
                    Aéro Emploi Inc. n’a pas de contrôle sur le contenu des autres sites accessibles par les liens présents sur ce site Web.
                    Le contenu de ce site Internet est protégé par les droits d’auteur (tous droits réservés). La reproduction, la
                    transmission, la modification ou l’utilisation à des fins commerciales sont interdites sans l’accord écrit préalable de
                    Aéro Emploi Inc.
                </p>

                <h2>Politique de Confidentialité en Ligne et Sécurité</h2>
                <p>
                    Aéro Emploi Inc. s’engage à assurer la protection et la confidentialité des renseignements personnels que vous
                    fournissez ou que nous recueillons lorsque vous visitez nos sites www.camaq.ca / www.camaq.ca /
                    www.camaq.ca / www.aeroweb.ca.
                </p>
                <p>
                    Les informations que nous recueillons, y compris les cookies de votre navigateur, votre adresse IP, la date et l’heure
                    de vos visites, ainsi que les données que vous nous fournissez lors du clavardage ou de l’envoi de CVs, sont utilisées
                    aux fins indiquées lors de la divulgation. Aéro Emploi Inc. ne communiquera jamais vos renseignements personnels à des
                    tiers non autorisés.
                </p>
                <p>
                    Nous utilisons des pixels et des fichiers GIF transparents pour des publicités de type remarketing. Ces fichiers nous
                    permettent de vous identifier lors de vos visites sur notre site et de vous servir des annonces aléatoires lorsque vous
                    visitez d’autres sites. Ces informations restent confidentielles et non identifiables personnellement. Pour plus
                    d'informations sur la façon de refuser cette technologie, consultez nos Règles de Confidentialité et Conditions
                    d’Utilisation.
                </p>

                <h2>Sécurité</h2>
                <p>Aéro Emploi Inc. applique des mesures de sécurité reconnues pour protéger vos renseignements personnels.</p>

                <h2>Collecte des Informations Personnelles :</h2>
                <p>
                    Nous pouvons collecter des informations personnelles telles que votre nom, adresse e-mail, numéro de téléphone et autres
                    données d'identification lorsque vous utilisez notre site. Ces informations sont recueillies de manière légale et
                    éthique, et nous ne collectons que les informations nécessaires à des fins spécifiques et légitimes.
                </p>

                <h2>Stockage et Sécurité des Informations :</h2>
                <p>
                    Nous mettons en place des mesures de sécurité appropriées pour protéger vos informations personnelles contre tout accès
                    non autorisé, altération, divulgation ou destruction. Vos données sont stockées sur des serveurs sécurisés et ne sont
                    accessibles qu'aux employés autorisés qui ont besoin de ces informations pour effectuer leur travail.
                </p>

                <h2>Utilisation des Informations Personnelles :</h2>
                <p>
                    Les informations personnelles que nous collectons sont utilisées aux fins pour lesquelles elles ont été fournies, telles
                    que répondre à vos demandes, traiter vos transactions ou vous envoyer des informations pertinentes.
                </p>

                <h2>Partage des Informations :</h2>
                <p>Nous pouvons partager vos informations personnelles avec des tiers dans les cas suivants</p>

                <ul>
                    <li>Pour répondre aux exigences légales, réglementaires ou judiciaires.</li>
                    <li>Pour protéger nos droits légaux ou répondre à des réclamations.</li>
                    <li>Avec votre consentement explicite.</li>
                </ul>

                <h2>Responsabilité</h2>
                <p>
                    Aéro Emploi Inc. s’engage à maintenir la confidentialité de vos renseignements personnels. Aéro Emploi Inc. ne cédera ni
                    ne divulguera vos renseignements personnels sauf en cas de demande légale contraignante. À votre demande, Aéro Emploi
                    Inc. corrigera ou supprimera vos renseignements personnels. Cependant, Aéro Emploi Inc. ne peut garantir l’exactitude
                    des informations fournies par les utilisateurs.
                </p>

                <h2>Changements à la Politique de Confidentialité et d'utilisation</h2>
                <p>
                    Aéro Emploi Inc. se réserve le droit de modifier cette Politique de Confidentialité à tout moment. Pour toute question,
                    contactez-nous par courriel à : info@camaq.ca
                </p>
                <p>Toutes les modifications seront publiées sur cette page avec la nouvelle date d'entrée en vigueur.</p>

                <h2>Politique de Facturation</h2>
                <p>
                    Pour annuler votre forfait, connectez-vous à votre compte entreprise et allez à la section "forfait". Cliquez sur
                    "annuler votre abonnement". Aucun remboursement ne sera effectué si l'annulation du forfait n'est pas faite avant la
                    date d'échéance.
                </p>

                <h2>Pour Nous Joindre</h2>

                <p>Aeroemploi Inc.</p>
                <p>Téléphone : 450-403-4300</p>
                <p>Courriel : info@camaq.ca</p>
                <p>Adresse : 1845, boulevard De Périgny, CP 184, Chambly, Canada J3L 4B3</p>

                <p>
                    <strong>Date de la Dernière Mise à Jour : 3 octobre 2023</strong>
                </p>
            </div>
        </div>

        <div v-if="locale == 'en'" class="prose mx-auto flex max-w-5xl flex-col space-y-4 py-10">
            <div class="prose mx-auto">
                <h2>Privacy and Usage Policy</h2>
                <p>
                    We use cookies and similar technologies to enhance user experience on our site. You can configure your browser to refuse
                    cookies, but this may affect certain site functionalities. By continuing, you agree to our usage and privacy policies.
                </p>

                <h2>Terms of Use</h2>
                <p>
                    The names AEROEMPLOI, AEROWEB, AEROCAREER, CAMAQ, and the Aeroemploi logos, including the lightning symbol, are
                    registered trademarks of Aéro Emploi Inc. All reproduction rights are owned by Aéro Emploi Inc., including reproduction
                    rights in the Aeroemploi logo. All rights reserved.
                </p>

                <h2>Legal Notice</h2>
                <p>
                    The information contained on this website is of a general nature and does not claim to replace personalized advice from
                    professionals taking into account the specifics of a particular case. Despite all the care taken in its preparation, we
                    cannot guarantee the accuracy, timeliness, reliability, or completeness of the information it contains. Aéro Emploi
                    Inc., its affiliates, partners, and employees cannot be held liable for any damage or loss related to the use of this
                    information.
                </p>
                <p>
                    Aéro Emploi Inc. has no control over the content of other sites accessible through links on this website. The content of
                    this website is protected by copyright (all rights reserved). Reproduction, transmission, modification, or commercial
                    use is prohibited without the prior written consent of Aéro Emploi Inc.
                </p>

                <h2>Online Privacy and Security</h2>
                <p>
                    Aéro Emploi Inc. is committed to ensuring the protection and confidentiality of the personal information you provide or
                    that we collect when you visit our site at www.camaq.ca / www.camaq.ca / www.camaq.ca / www.aeroweb.ca.
                </p>
                <p>
                    The information we collect, including your browser's cookies, your IP address, the date, and time of your visits, as
                    well as the data you provide us during chatting or when sending CVs, is used for the purposes indicated upon disclosure.
                    Aéro Emploi Inc. will never disclose your personal information to unauthorized third parties.
                </p>
                <p>
                    We use pixels and transparent GIF files for remarketing advertisements. These files allow us to identify you when you
                    visit our site and serve you random ads when you visit other sites. This information remains confidential and
                    non-personally identifiable. For more information on how to refuse this technology, please refer to our Privacy and
                    Usage Policy.
                </p>

                <h2>Security</h2>
                <p>Aéro Emploi Inc. implements recognized security measures to protect your personal information.</p>

                <h2>Collection of Personal Information</h2>
                <p>
                    We may collect personal information such as your name, email address, phone number, and other identifying data when you
                    use our site. This information is collected legally and ethically, and we only collect the necessary information for
                    specific and legitimate purposes.
                </p>

                <h2>Storage and Security of Information</h2>
                <p>
                    We implement appropriate security measures to protect your personal information against unauthorized access, alteration,
                    disclosure, or destruction. Your data is stored on secure servers and is only accessible to authorized employees who
                    need this information to perform their work.
                </p>

                <h2>Use of Personal Information</h2>
                <p>
                    The personal information we collect is used for the purposes for which it was provided, such as responding to your
                    requests, processing your transactions, or sending you relevant information.
                </p>

                <h2>Sharing of Information</h2>
                <p>We may share your personal information with third parties in the following cases:</p>

                <ul>
                    <li>To comply with legal, regulatory, or judicial requirements.</li>
                    <li>To protect our legal rights or respond to claims.</li>
                    <li>With your explicit consent.</li>
                </ul>

                <h2>Responsibility</h2>
                <p>
                    Aéro Emploi Inc. is committed to maintaining the confidentiality of your personal information. Aéro Emploi Inc. will not
                    disclose your personal information except in cases of compelling legal requests. Upon your request, Aéro Emploi Inc.
                    will correct or delete your personal information. However, Aéro Emploi Inc. cannot guarantee the accuracy of information
                    provided by users.
                </p>

                <h2>Changes to the Privacy and Usage Policy</h2>
                <p>
                    Aéro Emploi Inc. reserves the right to modify this Privacy and Usage Policy at any time. For any questions, contact us
                    by email at: info@camaq.ca
                </p>
                <p>All changes will be posted on this page with the new effective date.</p>

                <h2>Billing Policy</h2>
                <p>
                    To cancel your subscription, log in to your business account and go to the "subscription" section. Click on "cancel your
                    subscription." No refunds will be made if the subscription is not canceled before the expiration date.
                </p>

                <h2>Contact Us</h2>
                <p>Aeroemploi Inc.</p>
                <p>Phone: 450-403-4300</p>
                <p>Email: info@camaq.ca</p>
                <p>Address: 1845, De Périgny Boulevard, PO Box 184, Chambly, Canada J3L 4B3</p>

                <p><strong>Last Updated: October 3, 2023</strong></p>
            </div>
        </div>
    </Layout>
</template>

<script setup>
    import { computed } from 'vue';
    import { usePage } from '@inertiajs/inertia-vue3';

    const locale = computed(() => {
        return usePage().props.value.locale;
    });
</script>
